import {
  AvailableTimeslot,
  BookingOnLoadRes,
  CareProvider,
  Department,
  FormValues,
  GetAvailableTimeSlotsDetailReqConfig,
  GetAvailableTimeSlotsReqConfig,
  GetAvailableTimeSlotsRes,
  ServiceItem,
} from 'entities/Form';

export enum BookingModeV2 {
  Doctor = 1,
  Specialty,
  EKMC,
  BH,
}

export enum SpecialtyFlowTypeV2 {
  DoctorFirst = 1,
  ServiceFirst = 2,
}

export type DoctorPreferenceV2 = 'specific' | 'any';

export interface LocalizedOptionV2 {
  hid: string;
  nameTc: string;
  nameSc: string;
  nameEn: string;
}

export interface MasterServiceItemV2 extends LocalizedOptionV2 {
  ordering: number;
}

export interface ServiceItemV2 extends ServiceItem {
  nameEn: string;
  masterServiceItem: MasterServiceItemV2;
}

export interface CareProviderV2 extends Omit<CareProvider, 'serviceItems'> {
  nameEn: string;
  nameTc: string;
  nameSc: string;
  serviceItems?: ServiceItemV2[];
}

export interface DepartmentV2 extends Omit<Department, 'careProviders'> {
  careProviders?: CareProviderV2[];
}

export interface SpecialtyV2 extends LocalizedOptionV2 {
  code?: string;
  value: string;
  isShow: boolean;
  flowType?: SpecialtyFlowTypeV2;
  departmentOptions?: DepartmentV2[];
}

export interface BookingOnLoadResV2 extends Omit<BookingOnLoadRes, 'departmentOptions'> {
  specialtyOptions?: SpecialtyV2[];
}

export interface GetAvailableTimeSlotsReqConfigV2 extends Omit<
  GetAvailableTimeSlotsReqConfig,
  'serviceItemHid' | 'careProviderHid'
> {
  masterServiceItemHid: string;
  careProviderHids: string[];
}

export type GetAvailableTimeSlotsResV2 = Omit<GetAvailableTimeSlotsRes, 'departmentOptions'>;

export interface GetAvailableTimeSlotsDetailReqConfigV2 extends Omit<
  GetAvailableTimeSlotsDetailReqConfig,
  'serviceItemHid'
> {
  masterServiceItemHid: string;
}

export interface AvailableTimeslotDepartmentV2 extends LocalizedOptionV2 {
  siteCode?: string;
  siteNameEn: string;
  siteNameTc: string;
  siteNameSc: string;
}

export interface AvailableTimeslotV2 extends AvailableTimeslot {
  department: AvailableTimeslotDepartmentV2;
  serviceItemHid: string;
}

export interface GetAvailableTimeSlotsDetailResV2 {
  availableTimeslots: AvailableTimeslotV2[];
}

export interface CareProviderAvailableTimeslotV2 {
  careProvider: CareProviderV2;
  availableTimeslots: AvailableTimeslotV2[];
}

export interface FormValuesV2 extends FormValues {
  departmentHid?: string;
  siteCode?: string;
  specialtyHid?: string;
  specialtyValue?: string;
  specialtyOptionKey?: string;
  doctorPreference?: DoctorPreferenceV2;
  preferredCareProviderHid?: string;
  masterServiceItemHid?: string;
}
